import { MessageDto } from 'services/Message/messageService.dto';

export const isReceived = (message: MessageDto): boolean => {
  return (
    (!!message.deliveredToInterlocutors && message.deliveredToInterlocutors.length > 0) ||
    !!message.confirmationReceived
  );
};
